import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import { FormBox } from '../../css';

const SelectField = ({
  label,
  errors,
  touched,
  name,
  id,
  defaultVal,
  list,
  allowOptionNull,
  errorIcon,
  val,
  readOnly
}) => {
  return (
    <FormBox>
      <div className="main-content-form-headers">
        <span>{label}</span>
      </div>
      <div
        style={{ position: 'relative', width: '100%' }}
        className={`frg-select-container color-light input-container ${
          errors[name] && touched[name] ? 'error' : ''
        }`}
      >
        <Field
          as="select"
          id={id}
          name={name}
          className="select-style"
          defaultValue={defaultVal}
          disabled={readOnly}
        >
          {allowOptionNull && <option value={null} />}
          {list.map(l => (
            <option key={l.id} value={l.id}>
              {l[val]}
            </option>
          ))}
        </Field>
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors[name]}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={errorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </FormBox>
  );
};

SelectField.propTypes = {
  label: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types,react/require-default-props
  errors: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types,react/require-default-props
  touched: PropTypes.any,
  name: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types,react/require-default-props
  id: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types,react/require-default-props
  defaultVal: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types,react/require-default-props
  errorIcon: PropTypes.any,
  list: PropTypes.arrayOf(PropTypes.any).isRequired,
  allowOptionNull: PropTypes.bool,
  readOnly: PropTypes.bool,
  val: PropTypes.string.isRequired
};

SelectField.defaultProps = {
  allowOptionNull: true,
  readOnly: false
};

export default SelectField;
